import React from "react";
import styles from './apiList.less';
import html2canvas from "html2canvas";
import jsPDF from 'jspdf';

function ApiTool() {
    const exportHtml = (filename, data) => {
        // const urlobj = window.URL || window.webkitURL
        var eleLink = document.createElement('a');
        eleLink.download = filename + '.html';
        eleLink.style.display = 'none';
        // 字符内容转变成blob地址
        var blob = new Blob([data]);
        eleLink.href = URL.createObjectURL(blob);
        // 触发点击
        document.body.appendChild(eleLink);
        eleLink.click();
        // 然后移除
        document.body.removeChild(eleLink);
    }
    const exportPDF = (filename, data) => {
        html2canvas(data, {
            // allowTaint: true,
            scale: 2,
        }).then(function (canvas) {
            let contentWidth = canvas.width
            let contentHeight = canvas.height
            // 不分页
            let imgHeight = 841.89
            let imgWidth = 841.89 / contentHeight * contentWidth
            let pageData = canvas.toDataURL('image/jpeg', 1.0);
            let PDF = new jsPDF('', 'pt', 'a4');
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
            PDF.save(filename + '.pdf');
        })
    }
    const handleClickHTML = () => {
        const downloadData = document.querySelector('#download').outerHTML;
        exportHtml('apilist', downloadData)
    }

    const handleClickPDF = () => {
        const downloadData = document.querySelector('#download');
        exportPDF('apilist', downloadData)
    }

    return (
        <div id='apitool' className={`${styles.apitool} controledanchor`}>
            <h2>API工具</h2>
            <div className={styles.apitoolcontent}>
                <a className={styles.aHide} href='#'>API测试工具</a>
                <a onClick={handleClickHTML}>导出HTML</a>
                <a onClick={handleClickPDF}>导出PDF</a>
                <a className={styles.aHide} href='#'>SDK下载</a>
            </div>
        </div>
    )
}

export default ApiTool;